import React from 'react';
import PropTypes from 'prop-types';
import Bundle from '@saucelabs/sl-component-bundle';
import { Route, Switch, Redirect } from 'react-router-dom';
import { InExperimentContainer } from '@saucelabs/sl-container-experiment';
import { apiBaseUrls } from '@saucelabs/sl-util-config';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

import OrgAdminContainer from './containers/OrgAdminContainer';
import billingReducer from './reducers';
import {
  ROUTE_PARENT_SECTION,
  ROUTE_SECTION_ACCOUNT,
  ROUTE_SECTION_PURCHASE,
} from './constants';

const importBilling = () => import(/* webpackChunkName: "billing" */ './containers/BillingContainer');
const importPurchaseWizard = () => import(/* webpackChunkName: "purchase" */ './components/PurchaseWizard');

const BillingRedirect = () => {
  window.location.href = apiBaseUrls.billing;
};

const Billing = ({ match }) => (
  <LoginRequiredContainer>
    <InExperimentContainer name="web-ui-billing">
      <SentryBoundary owner={sentryConstants.TEAMS.WEB_PLATFORM}>
        <OrgAdminContainer>
          <Switch>
            <Route
              path={`${match.url}/${ROUTE_SECTION_ACCOUNT}/:tabName?`}
              render={(props) => (
                <Bundle load={importBilling}>
                  {(Component) => (
                    <Component
                      activeTab={match.url}
                      {...props}
                    />
                  )}
                </Bundle>
              )}
            />
            <Route
              path={`${match.url}/${ROUTE_SECTION_PURCHASE}/:wizardStep?`}
              render={(props) => (
                <Bundle load={importPurchaseWizard}>
                  {(Component) => (
                    <Component
                      activeTab={match.url}
                      {...props}
                    />
                  )}
                </Bundle>
              )}
            />
            {/* default route is /billing/my-account */}
            <Redirect
              from={`/${ROUTE_PARENT_SECTION}`}
              to={`/${ROUTE_PARENT_SECTION}/${ROUTE_SECTION_ACCOUNT}`}
            />
            {/* Redirect if there no Route match to switch */}
            <Route component={BillingRedirect} />
          </Switch>
        </OrgAdminContainer>
      </SentryBoundary>
    </InExperimentContainer>
  </LoginRequiredContainer>
);

Billing.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.billing', attachReducer(billingReducer),
)(Billing);
